export const validatePostalCode = (postalCode) => {
  if (!postalCode) {
    return true;
  }
  const postalCodeWithoutDashes = postalCode.replace(/-/g, '');
  const reg = /^[0-9]{2}-?[0-9]{3}$/;
  return reg.test(postalCodeWithoutDashes);
};
